module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/body-texture-selected.ec0719a5.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/body-texture-selected.png
// module id = 2532
// module chunks = 11